import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Whisper, Tooltip } from "rsuite";
import { RiGridFill, RiListUnordered } from "react-icons/ri";
import { FiUser, FiSearch, FiX } from "react-icons/fi";
import ReportsTable from "./ReportsTable";

import { useLazyGetLabReportsQuery, useLazyGetLabReportsListQuery, usePostFilteredLabReportsMutation } from "../State/Api/AddLabReportsApiSlice";
import ClinicsideReportsfilters from "./ClinicsideReportsfilters";
import DefaultPatientFilters from "./ClinicComponent/Filters/DefaultPatientFilters";
import ReportsViewFilters from "./ClinicComponent/Filters/ClinicFilterJSON/ReportsView";

function PatientReports() {
  const navigate = useNavigate();

  const [activeView, setActiveView] = useState("list");
  const [reportSearch, setReportSearch] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
    const gridRef = useRef(null);
    const [hasData, setHasData] = useState(true);

      const prevFiltersRef = useRef([]);
    
      useEffect(() => {
        // Only purge if filters actually changed
        if (
          JSON.stringify(prevFiltersRef.current) !== JSON.stringify(selectedFilters)
        ) {
          gridRef?.current?.api?.purgeInfiniteCache();
          prevFiltersRef.current = selectedFilters;
        }
      }, [selectedFilters]);


  const clinicUserId = localStorage.getItem("userClinicID");



  const [triggerGetReports, { data, isLoading: addLoading }] = useLazyGetLabReportsQuery();

  
const [fetchLabReports, {isLoading: postLoading, isSuccess: postSuccess, isFetching: postFetching}] = usePostFilteredLabReportsMutation();


      const getLabReports = async (pageNumber, filters, sortColumn = "", sortOrder = "") => {
      try {
        const result = await fetchLabReports({
          pageNumber: pageNumber,
          pageSize: 100,
          userClinicID: clinicUserId,
            doctorUserUniqueID: "",
          filters: filters,
          sortColumn: sortColumn,
          sortOrder: sortOrder
        }).unwrap();
        return result;
      } catch (err) {
        console.error("Error fetching reports:", err);
    return [];
      }
    };


  const handleAddReport = async () => {
    const userclinicid = localStorage.getItem("userClinicID");
    if (!userclinicid) return;

    const result = await triggerGetReports(userclinicid);

    if (result?.data) {
      navigate("/AddPatientReports", {
        state: {
          reportData: result.data,
        },
      });
    }
  };

  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive ? "bg-[#203342] text-white" : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };

    const handleSearch = () => {
      let searchValue = reportSearch.trim();
  
      if (!searchValue) {
        // Clear filters if search empty
        setSelectedFilters((prev) => {
          const { patientName, patientUserUniqueID, ...rest } = prev;
          return rest;
        });
        return;
      }
  
      let newFilter;
  
      if (/^PLCRXPAT\d+$/i.test(searchValue)) {
        // Already formatted Patient ID
        newFilter = {
          patientUserUniqueID: {
            values: new Set([searchValue]),
            operator: "Contains",
          },
        };
      } else if (/^\d+$/.test(searchValue)) {
        // Only numbers → prepend prefix
        const prefixedValue = `PLCRXPAT${searchValue}`;
        newFilter = {
          patientUserUniqueID: {
            values: new Set([prefixedValue]),
            operator: "Contains",
          },
        };
      } else {
        // Otherwise treat as name
        newFilter = {
          patientName: {
            values: new Set([searchValue]),
            operator: "Contains",
          },
        };
      }
  
      setSelectedFilters((prev) => {
        const { patientName, patientUserUniqueID, ...rest } = prev;
        return { ...rest, ...newFilter };
      });
    };
  
    const handleClearSearch = () => {
      setReportSearch("");
      setSelectedFilters((prev) => {
        const { patientName, patientUserUniqueID, ...rest } = prev;
        return rest;
      });
      setHasData(true);
    };
  


  return (
    <main className="w-100" style={{ height: "100%" }}>
      <div className="row">
        <div
          className="col-12 mb-4 d-flex flex-wrap justify-content-between align-items-center"
          style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
        >
          <div>
            <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>Patient Lab Reports</h2>
            {/* <p className="text-secondary mb-2">Monitor patient progress through organized Lab reports.</p> */}
          </div>

          <div className="d-flex flex-wrap align-items-center gap-3">
       <label className="relative">
                <input
                  type="text"
                  className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm   focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                  placeholder="Enter patient name or ID"
                  value={reportSearch}
                  onChange={(e) => {
                    const value = e.target.value;
                    setReportSearch(value);

                    if (value.trim() === "") {
                      setSelectedFilters((prev) => {
                        const { patientName, patientIDUniqueID, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />
                {reportSearch && (
                  <span
                    className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
                    onClick={handleClearSearch}
                  >
                    <FiX size={16} />
                  </span>
                )}
                <span
                  className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-gray-200 p-2 rounded-md text-white cursor-pointer"
                  onClick={handleSearch}
                >
                  <FiSearch size={16} />
                </span>
              </label>


            <Whisper placement="top" trigger="hover" speaker={<Tooltip>Filter Options</Tooltip>}>
                 <DefaultPatientFilters
                                  defaultFilters={ReportsViewFilters.default}
                                  additionalFilters={ReportsViewFilters.additional}
                                  selectedFilters={selectedFilters}
                                  setSelectedFilters={setSelectedFilters}
                                  setHasData={setHasData}
                                />
              </Whisper>

            <button
              className="gradient-button d-flex align-items-center justify-content-center"
              onClick={handleAddReport}
              disabled={addLoading}
            >
              {addLoading ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              ) : (
                "+ Add Report"
              )}
            </button>
            <div className="flex rounded-md overflow-hidden shadow-sm border border-gray-200 ml-[5px] w-fit">
              <Whisper placement="top" trigger="hover" speaker={<Tooltip>List view</Tooltip>}>
                <button onClick={() => setActiveView("list")} className={getButtonClasses("list")}>
                  <RiListUnordered size={20} />
                </button>
              </Whisper>
              
            </div>
          </div>
        </div>
      </div>

      {activeView === "list" && (
        <ReportsTable
          getLabReports={getLabReports}
          isLoading={postLoading}
          isFetching={postFetching}
          isSuccess={postSuccess}
              gridRef={gridRef}
                selectedFilters={selectedFilters}
                hasData={hasData}          
                setHasData={setHasData} 
        />
      )}
    </main>
  );
}

export default PatientReports;
